import {Button, Header} from '@amzn/awsui-components-react';
import Box from '@amzn/awsui-components-react/polaris/box';
import ExpandableSection from '@amzn/awsui-components-react/polaris/expandable-section';
import Grid from '@amzn/awsui-components-react/polaris/grid';
import React, {useState} from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {SubmissionDetails} from '../../backend/model';
import {prettifyDateUTC} from "../workflow/date";
import {executeSubmission, updateSubmission} from "../../backend/backend";
import ActionRow from "./ActionRow";
import AjaxStatusIndicator from "../basic/AjaxStatusIndicator";
import {parseErrorMessage} from "../../utils/errors";

import "./SubmissionDetailsPanel.css";

interface SubmissionDetailsPanelProps extends RouteComponentProps {
    submissionDetails: SubmissionDetails;
    triggerReRender: () => void;
}

const SubmissionDetailsPanel: React.FC<SubmissionDetailsPanelProps> = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessages, setErrorMessages] = useState<string[]>([])

    async function executeSubmissionTask(id: string) {
        setIsLoading(true)

        try {
            const response = (await executeSubmission(id)).data
            return response;
        } catch (error: any) {
            console.error(error)
            setErrorMessages([parseErrorMessage(error)])
        } finally {
            setIsLoading(false)
        }
    }

    async function updateSubmissionTask(submissionDetails: SubmissionDetails) {
        setIsLoading(true)

        try {
            const response = (await updateSubmission(submissionDetails.submissionId, submissionDetails)).data
            return response;
        } catch (error: any) {
            console.error(error)
            setErrorMessages([parseErrorMessage(error)])
        } finally {
            setIsLoading(false)
        }
    }

    function approve() {
        const submissionDetails = {
            ...props.submissionDetails,
            approverFromFrontend: props.submissionDetails.actorId
        }
        updateSubmissionTask(submissionDetails).then(data => {
            props.triggerReRender()
        }).catch(error => {
            console.error(error)
        })
    }

    function execute() {
        executeSubmissionTask(props.submissionDetails.submissionId).then(data => {
            props.triggerReRender()
        }).catch(error => {
            console.error(error)
        })
    }

    const summary = (
        <>
            <Grid
                disableGutters
                gridDefinition={[
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 6, xxs: 2}},
                    {colspan: {default: 6, xxs: 4}},
                    {colspan: {default: 12, xxs: 2}},
                    {colspan: {default: 12, xxs: 10}},
                    {colspan: {default: 12, xxs: 2}},
                    {colspan: {default: 12, xxs: 10}},
                ]}>
                <Box variant="p" id='whdp-submissionID'>Submission ID:</Box>
                <Box variant="p" id='whdp-submissionId'>{props.submissionDetails.submissionId}</Box>

                <Box variant="p">Author: </Box>
                <Box variant="p" id='whdp-author'>{props.submissionDetails.author}</Box>

                <Box variant="p">Creation Date: </Box>
                <Box variant="p" id='whdp-data'>{prettifyDateUTC(new Date(props.submissionDetails.creationDate))}</Box>

                <Box variant="p">Status: </Box>
                <Box id='whdp-status'>{props.submissionDetails.status}</Box>

                <Box variant="p">Reference: </Box>
                <Box id='whdp-status'>{props.submissionDetails.reference}</Box>

                <Box variant="p">Approvers: </Box>
                <Box id='whdp-status'>{props.submissionDetails.approversStr}</Box>

                <Box variant="p">Actions: </Box>
            </Grid>

            {props.submissionDetails.actionProps.map((action, i) => (
                <ActionRow
                    key={i}
                    selectedActionName={action.actionName}
                    selectedActionParamNames={action.actionParamNames}
                    selectedActionParamValues={action.actionParamValues}
                    selectableActionNames={[]}
                    setSelectedAction={() => {}}
                    setActionParamValues={() => {}}
                    getStepOptions={() => ([])}
                    isEditable={false}
                />
            ))}

            <br/>
            <Button
                id='approvebutton'
                variant="primary"
                onClick={approve}
                disabled={!props.submissionDetails.canApprove}
            >
                Approve
            </Button>
            &nbsp; &nbsp; &nbsp;
            <Button
                id='executebutton'
                variant="primary"
                onClick={execute}
                disabled={!props.submissionDetails.canExecute}
            >
                Execute
            </Button>
            <br/>
            <AjaxStatusIndicator errorMessage={errorMessages.join(' ')} loading={isLoading} className="submission-details-panel-status"/>
        </>
    )

    return (
        <ExpandableSection
            id='submissionDetailsPanel'
            variant='container'
            header={<Header variant='h2'>Details</Header>}
            defaultExpanded>
            {summary}
        </ExpandableSection>
    )
}

export default withRouter(SubmissionDetailsPanel)
